import styled from '@emotion/styled';

export const PaginationContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 3.2rem;
	width: 100%;

	.pagination {
		display: flex;
		justify-content: center;
		border-radius: ${(props) => props.theme.effects.radiusMd};
		overflow: hidden;
		box-shadow: ${(props) => props.theme.effects.shadowSm};

		li {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 3.6rem;
			height: 3.8rem;
			min-width: 2.8rem;
			font-size: ${(props) => props.theme.fontSize.sizeSm};
			font-weight: ${(props) => props.theme.fontWeight.weightRegular};
			transition: all ${(props) => props.theme.effects.transitionFast};
			border: 1px solid ${(props) => props.theme.colors.gray100};
			border-right: none;
			cursor: pointer;
			background-color: #fff;

			a {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 100%;
				height: 100%;
				color: ${(props) => props.theme.colors.gray200};
			}

			&.active {
				background-color: ${(props) => props.theme.colors.primary400};

				a {
					color: #fff;
					font-weight: ${(props) => props.theme.fontWeight.weightSemi};
				}
			}

			&:hover:not(.active):not(.disabled) {
				background-color: ${(props) => props.theme.colors.primary50};

				a {
					color: ${(props) => props.theme.colors.primary400};
				}
			}

			&:last-of-type {
				border-right: 1px solid ${(props) => props.theme.colors.gray100};
			}

			&.first-page-btn,
			&.last-page-btn,
			&.prev-page-btn,
			&.next-page-btn {
				background-color: ${(props) => props.theme.colors.gray};

				&:hover:not(.disabled) {
					background-color: ${(props) => props.theme.colors.primary50};
				}
			}

			&.disabled {
				cursor: not-allowed;
				opacity: 0.5;

				&:hover {
					background-color: #fff;
				}
			}
		}
	}
`;
